import { Injectable } from "@angular/core";

@Injectable({
    providedIn:'root'
})
export class LoggerService{
    logError(message:string,stack:string){
        const errorPayload={
            timestamp:new Date().toISOString(),
            url:window.location.href,
            message,
            stack,
            browser:navigator.userAgent
        };

        console.error('Logging error :' ,errorPayload);
    }

}